module.exports = __webpack_public_path__ + "static/media/loveUnSelected.40971d6d.webp";